import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { toast } from "react-toastify";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function Terms({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [value2, setValue2] = useState("one");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const fileInput = useRef();

  let userToken = localStorage.getItem("userToken");

  const [uploadType, setUploadType] = useState("");

  const handleClick = (type) => {
    setUploadType(type);
    fileInput.current.click();
  };

  const handleFileChange = async (event, index) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await fetch(`${API}/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const res = await response.json();

      let fileURL = res[0]?.url;
      let dataDocs = [...data];

      if (uploadType === "Privacy Policy") {
        dataDocs[index].pFile = fileURL;
      } else if (uploadType === "ML Rules") {
        dataDocs[index].mFile = fileURL;
      } else if (uploadType === "T&C") {
        dataDocs[index].tFile = fileURL;
      }

      await fetch(`${API}/terms`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { terms: dataDocs },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setData(dataDocs);
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      });

      if (fileInput.current) {
        fileInput.current.value = "";
      }
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      p: "",
      m: "",
      t: "",
      pFile: "",
      mFile: "",
      tFile: "",
      language: item.attributes.language,
    }));
    setData(docs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);

    async function getData() {
      await fetch(`${API}/terms`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.terms || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                p: apiItem.p || localItem.p,
                m: apiItem.m || localItem.m,
                t: apiItem.t || localItem.t,
                pFile: apiItem.pFile || localItem.pFile,
                mFile: apiItem.mFile || localItem.mFile,
                tFile: apiItem.tFile || localItem.tFile,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/terms`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { terms: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.terms
          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Policies Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

                  <TabContext value={value2}>
                    <Tabs
                      value={value2}
                      textColor="secondary"
                      indicatorColor="secondary"
                      onChange={handleChange2}>
                      <Tab sx={tabStyle} label={"Privacy Policy"} value={"one"} />
                      <Tab sx={tabStyle} label={"Anti Money Laundering Rules"} value={"two"} />
                      <Tab sx={tabStyle} label={"Terms & Conditions"} value={"three"} />
                      <Tab
                        style={{ display: user.perms[6].edit ? null : "none" }}
                        sx={tabStyle}
                        label={"PDFs"}
                        value={"four"}
                      />
                    </Tabs>

                    <TabPanel value="one">
                      <div style={{ margin: "20px 0" }}>
                        <TextEditor
                          value={data[index]?.p || ""}
                          onChange={(v) => {
                            setData([
                              ...data.map((item, idx) => {
                                if (idx === index) {
                                  return {
                                    ...item,
                                    p: v,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel value="two">
                      <div style={{ margin: "20px 0" }}>
                        <TextEditor
                          value={data[index]?.m || ""}
                          onChange={(v) => {
                            setData([
                              ...data.map((item, idx) => {
                                if (idx === index) {
                                  return {
                                    ...item,
                                    m: v,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel value="three">
                      <div style={{ margin: "20px 0" }}>
                        <TextEditor
                          value={data[index]?.t || ""}
                          onChange={(v) => {
                            setData([
                              ...data.map((item, idx) => {
                                if (idx === index) {
                                  return {
                                    ...item,
                                    t: v,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }}
                        />
                      </div>
                    </TabPanel>

                    <TabPanel value="four">
                      <div
                        className="flex"
                        style={{
                          margin: "20px 0",
                          gap: 60,
                          justifyContent: "flex-start",
                        }}>
                        {["Privacy Policy", "ML Rules", "T&C"].map((label) => (
                          <div key={label} onClick={() => handleClick(label)}>
                            <div className="flex border-dashed border-2 rounded-md mb-2 w-28 aspect-square cursor-pointer hover:bg-gray-100 transition-all delay-100">
                              <FileUploadIcon
                                sx={{
                                  fontSize: 40,
                                  color:
                                    data[index]?.[
                                      `${label.slice(0, 1).toLocaleLowerCase()}File`
                                    ] !== ""
                                      ? "green"
                                      : "#999",
                                }}
                              />
                            </div>
                            <p className="text-center">{label}</p>
                          </div>
                        ))}
                      </div>

                      <input
                        type="file"
                        accept="application/pdf"
                        ref={fileInput}
                        className="hidden"
                        onChange={(e) => handleFileChange(e, index)}
                      />
                    </TabPanel>
                  </TabContext>

                  <div
                    style={{ display: user.perms[6].edit ? null : "none" }}
                    className="submitBTN"
                    onClick={() => submitData(item, index)}>
                    Save Changes
                  </div>
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
